<template>
    <div class="cityRanking">
        <b-container v-if="!isApp" class="title">
            <h1>{{ $t('cityRanking.title')}}{{dateSelector.label}}</h1>
            <p>{{ $t('cityRanking.subTitle')}}</p>
        </b-container>

        <el-container class="ranking-table" v-if="!isApp">
            <b-container>
                <div class="selection">
                    <el-cascader
                        expand-trigger="click"
                        :options="options"
                        :placeholder="$t('cityRanking.allCountry')"
                        popper-class="popperStyle"
                        v-model="selectedOptions2"
                        :show-all-levels="false"
                        @change="cascaderChange"
                        clearable
                    ></el-cascader>

                    <div class="share-btn" hidden>
                        <div class="media-box">
                            <a target="_blank" href="https://fb.com"></a>
                            <a target="_blank" href="https://twitter.com"></a>
                            <a target="_blank" href="https://linkedin.com"></a>
                            <a target="_blank" href="https://t.cn"></a>
                        </div>
                    </div>

                    <el-select
                        v-if="window_size > 576"
                        v-model="dateSelector"
                        :placeholder="$t('cityRanking.select')"
                        class="past_months"
                        @change="selectHandler"
                    >
                        <el-option
                            v-for="(item, index) in dates"
                            :key="index"
                            :label="item.label"
                            :value="item"
                        ></el-option>
                    </el-select>
                    <div v-if="window_size < 576" class="past_months">
                        <input
                            type="text"
                            readonly="readonly"
                            :placeholder="$t('cityRanking.selectOne')"
                            class="fake_input"
                            @click.prevent="openPop('date')"
                            :value="dateSelector.label"
                        />
                    </div>
                </div>

                <div v-if="window_size < 576" class="past_months">
                    <input
                        type="text"
                        readonly="readonly"
                        class="fake_input"
                        @click.prevent="openPop('comparison')"
                        :value="comparisonSelector.label"
                    />
                </div>

                <el-table
                    :data="tableData.filter(it => !filter_cascader || (it.continent.includes(filter_cascader) || it.country == filter_cascader) )"
                    header-row-class-name="table_header_normal"
                    row-class-name="table_body_normal"
                    :default-sort="{prop:'index', order:'ascending'}"
                    :empty-text="$t('cityRanking.noResult')"
                    :header-cell-style="restrictStyle"
                >
                    <!-- rank -->
                    <el-table-column
                        v-if="window_size > 576"
                        prop="index"
                        sortable
                        class-name="table_body_bold"
                        :sort-orders="['ascending', 'descending']"
                        min-width="15%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>
                                {{ $t('cityRanking.cityRank')}}
                                <i></i>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <span class="table_body_index">{{scope.row.rank}}</span>
                            <span class="table_body_normal-ff">({{scope.row.rank_change}})</span>
                            <span
                                class="table_body_normal-change"
                                :class="{ up: scope.row.rank_change > 0, down: scope.row.rank_change <  0 }"
                            >
                                <span
                                    v-if="scope.row.rank_change == '-'"
                                    class="rankNoChange"
                                >{{scope.row.rank_change}}</span>
                            </span>
                        </template>
                    </el-table-column>
                    <!-- name -->
                    <el-table-column
                        prop="window_size > 576 ? city : index"
                        sortable
                        :sort-method="window_size > 576 ? sortAlphabetically : null"
                        :sort-orders="['ascending', 'descending']"
                        class-name="city"
                        min-width="16%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div v-if="window_size > 576">{{ $t('cityRanking.city')}}</div>
                            <div v-else>{{ $t('cityRanking.cityRank')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <div v-if="window_size < 576">
                                <span class="table_body_index">{{scope.row.rank}}</span>
                                <span class="table_body_normal-ff">({{scope.row.rank_change}})</span>
                                <span
                                    class="table_body_normal-change"
                                    :class="{ up: scope.row.rank_change > 0, down: scope.row.rank_change <  0 }"
                                >
                                    <span
                                        v-if="scope.row.rank_change == '-'"
                                        class="rankNoChange"
                                    >{{scope.row.rank_change}}</span>
                                </span>
                            </div>
                            <div>
                                <a
                                    v-if="scope.row.has_projects"
                                    class="hyperlink"
                                    :href="scope.row.url"
                                    target="_blank"
                                >
                                    <div
                                        :class="`flag flag-icon flag-icon-${scope.row.country.toLowerCase()}`"
                                    ></div>
                                    {{scope.row.city}}
                                </a>
                                <span v-if="!scope.row.has_projects" class="hyperlink">
                                    <div
                                        :class="`flag flag-icon flag-icon-${scope.row.country.toLowerCase()}`"
                                    ></div>
                                    {{scope.row.city}}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- score -->
                    <el-table-column
                        v-if="(window_size > 576) || comparisonSelector.value == 0"
                        prop="score"
                        align="right"
                        class-name="table_body_bold score"
                        min-width="10%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scoped">
                            <div class="info">
                                {{ $t('cityRanking.cityScore')}}
                                <span class="info-icon">
                                    <span>{{ $t('cityRanking.tooltip')}}</span>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- growth rate -->
                    <el-table-column
                        v-if="(window_size > 576 ) || comparisonSelector.value == 1"
                        prop="population_growth_rate"
                        sortable
                        :sort-method="sortDecimal"
                        :sort-orders="['descending', 'ascending']"
                        align="right"
                        min-width="17%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>{{ $t('cityRanking.avgGrowth')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <span
                                style="padding-right: 10px"
                            >{{ scope.row.population_growth_rate | addPct}}</span>
                        </template>
                    </el-table-column>
                    <!-- median price -->
                    <el-table-column
                        v-if="(window_size > 576 ) || comparisonSelector.value == 2"
                        align="right"
                        sortable
                        :sort-method="sortInt_sqft"
                        :sort-orders="['ascending', 'descending']"
                        min-width="12%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div class="table_body_header table_body_header_bold">
                                {{ $t('cityRanking.medianPrice')}}
                                <span>({{ currency }}/{{ unit }})</span>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <span style="padding-right: 10px">{{ scope.row.median_price_per_sqm}}</span>
                        </template>
                    </el-table-column>
                    <!-- yield -->
                    <el-table-column
                        v-if="(window_size > 576 ) || comparisonSelector.value == 3"
                        prop="median_gross_yield"
                        sortable
                        align="right"
                        :sort-method="sortDecimal_yield"
                        :sort-orders="['descending', 'ascending']"
                        min-width="14%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>{{ $t('cityRanking.grossYield')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <span>{{ scope.row.median_gross_yield | addPct}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <BackToTop></BackToTop>
            </b-container>
        </el-container>

        <CityRankingSelection
            v-if="pop == 'comparison' || pop == 'date' || pop == 'country'"
            @pop_callback="pop_callback"
            :field="{dates: dates, date: dateSelector, comparisons: comparisons, comparison: comparisonSelector, country: countrySelector, countries: options}"
            :which_pop="pop"
        ></CityRankingSelection>

        <b-container fluid v-if="isApp" class="app_container">
            <div class="app_nav">
                <div class="past_months">
                    <input
                        type="text"
                        :placeholder="$t('cityRanking.allCountry')"
                        readonly="readonly"
                        class="fake_input"
                        @click.prevent="openPop('country')"
                        :value="countrySelector.label"
                    />
                </div>
                <div class="past_months">
                    <input
                        type="text"
                        :placeholder="$t('cityRanking.selectOne')"
                        readonly="readonly"
                        class="fake_input"
                        @click.prevent="openPop('date')"
                        :value="dateSelector.label"
                    />
                </div>
                <div class="past_months">
                    <input
                        type="text"
                        :placeholder="$t('cityRanking.selectOne')"
                        readonly="readonly"
                        class="fake_input"
                        @click.prevent="openPop('comparison')"
                        :value="comparisonSelector.label"
                    />
                </div>
            </div>

            <div class="app_table">
                <el-table
                    :data="tableData.filter(it => !filter_cascader || (it.continent.includes(filter_cascader) || it.country == filter_cascader) )"
                    header-row-class-name="table_header_normal"
                    row-class-name="table_body_normal"
                    :default-sort="{prop:'index', order:'ascending'}"
                    :empty-text="$t('cityRanking.noResult')"
                    :header-cell-style="restrictStyle"
                >
                    <!-- rank -->
                    <el-table-column
                        prop="window_size > 576 ? city : index"
                        :sort-method="window_size > 576 ? sortAlphabetically : null"
                        :sort-orders="['ascending', 'descending']"
                        class-name="city"
                        min-width="16%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>{{ $t('cityRanking.cityRank')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <div class="selection-l">
                                <span class="table_body_index">{{scope.row.rank}}</span>
                                <span class="table_body_normal-ff">({{scope.row.rank_change}})</span>
                                <span
                                    class="table_body_normal-change"
                                    :class="{ up: scope.row.rank_change > 0, down: scope.row.rank_change <  0 }"
                                >
                                    <span
                                        v-if="scope.row.rank_change == '-'"
                                        class="rankNoChange"
                                    >{{scope.row.rank_change}}</span>
                                </span>

                                <span
                                    v-if="scope.row.has_projects"
                                    class="hyperlink"
                                    :href="scope.row.url"
                                    target="_blank"
                                >
                                    <div
                                        :class="`flag flag-icon flag-icon-${scope.row.country.toLowerCase()}`"
                                    ></div>
                                    {{scope.row.city}}
                                </span>
                                <span v-if="!scope.row.has_projects" class="hyperlink">
                                    <div
                                        :class="`flag flag-icon flag-icon-${scope.row.country.toLowerCase()}`"
                                    ></div>
                                    {{scope.row.city}}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- score -->
                    <el-table-column
                        v-if="comparisonSelector.value == 0"
                        prop="score"
                        align="right"
                        width="100"
                        class-name="table_body_bold score"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scoped">
                            <div class="info">
                                {{ $t('cityRanking.cityScore')}}
                                <span class="info-icon">
                                    <!-- <span>{{ $t('cityRanking.tooltip')}}</span> -->
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- growth rate -->
                    <el-table-column
                        v-if="comparisonSelector.value == 1"
                        prop="population_growth_rate"
                        width="120"
                        :sort-method="sortDecimal"
                        :sort-orders="['descending', 'ascending']"
                        align="right"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>{{ $t('cityRanking.avgGrowth')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <span
                                style="padding-right: 10px"
                            >{{ scope.row.population_growth_rate | addPct}}</span>
                        </template>
                    </el-table-column>
                    <!-- median price -->
                    <el-table-column
                        v-if="comparisonSelector.value == 2"
                        align="right"
                        width="120"
                        :sort-method="sortInt_sqft"
                        :sort-orders="['ascending', 'descending']"
                        min-width="12%"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div class="table_body_header table_body_header_bold">
                                {{ $t('cityRanking.medianPrice')}}
                                <span>({{ currency }}/{{ unit }})</span>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <span style="padding-right: 10px">{{ scope.row.median_price_per_sqm}}</span>
                        </template>
                    </el-table-column>
                    <!-- yield -->
                    <el-table-column
                        v-if="comparisonSelector.value == 3"
                        prop="median_gross_yield"
                        width="100"
                        align="right"
                        :sort-method="sortDecimal_yield"
                        :sort-orders="['descending', 'ascending']"
                        :key="Math.random()"
                    >
                        <template slot="header" slot-scope="scope">
                            <div>{{ $t('cityRanking.grossYield')}}</div>
                        </template>
                        <template slot-scope="scope">
                            <span>{{ scope.row.median_gross_yield | addPct}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </b-container>
    </div>
</template>

<script>
import CityRankingSelection from "@/components/CityRanking_selection";
import BackToTop from "@/components/BackToTop";
let loading;

export default {
    data() {
        return {
            window_size: undefined,
            tableData: [],
            dates: [],
            dateSelector: {},
            comparisons: [
                {
                    value: 0,
                    label: this.$t("cityRanking.cityScore")
                },
                {
                    value: 1,
                    label: this.$t("cityRanking.avgGrowth")
                },
                {
                    value: 2,
                    label: this.$t("cityRanking.medianPrice")
                },
                {
                    value: 3,
                    label: this.$t("cityRanking.grossYield")
                }
            ],
            comparisonSelector: {
                value: 0,
                label: this.$t("cityRanking.cityScore")
            },
            countrySelector: {},
            filter_cascader: undefined,
            pop: undefined,
            options: [],
            selectedOptions: [],
            selectedOptions2: []
        };
    },

    beforeMount() {
        this.tableData = this.$root.cities;
        this.dates = this.$root.dates;
        this.dateSelector = this.$root.dates[0];
        this.unit = this.$root.unit;
        this.currency = this.$root.currency;

        this.window_size = window.screen.width;

        this.isApp = "app" in this.$route.query;

        let arr = this.$root.regionGroup;
        for (let i = 0; i < arr.length; i++) {
            arr[i].children.unshift({
                label: this.$t("cityRanking.all") + arr[i].label,
                value: arr[i].value
            });
            this.options.push(arr[i]);
        }
        this.options.unshift({
            label: this.$t("cityRanking.allCountry"),
            value: ""
        });
    },

    mounted() {
        setTimeout(() => {
            this.getHashTag();
        }, 1500);
    },

    methods: {
        getHashTag() {
            if (!this.$route.hash) return;

            let hash_num = this.$route.hash.split("#")[1];

            this.elevator(hash_num);
        },

        elevator(num) {
            let target = document.querySelectorAll(".table_body_index")[num];

            $("html, body").animate(
                {
                    scrollTop: $(target).offset().top - 90 // 90 is target height
                },
                700
            );
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".el-table",
                text: "Loading...",
                spinner: "el-icon-loading",
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        filterCountry(value, row) {
            return row.country === value;
        },

        openPop(flag, event) {
            this.pop = flag;
        },

        pop_callback(data) {
            this.pop = undefined;
            if (data.isCancelAction) return;
            this.dateSelector = data.date;
            this.comparisonSelector = data.comparison;
            this.countrySelector = data.country;

            if (data.flag == "country") {
                this.filter_cascader = this.countrySelector.value;
            }

            if (data.flag == "date") {
                this.selectHandler(this.dateSelector);
            }
        },

        selectHandler(val) {
            if (!"app" in this.$route.query) {
                this.loading();
            }

            this.$http.get(val.value, {}).then(result => {
                this.tableData = result.data;
                if (!"app" in this.$route.query) {
                    loading.close();
                }
            });
        },

        sortAlphabetically(a, b) {
            return a.city.localeCompare(b.city);
        },

        sortDecimal(a, b) {
            let a1 = a.population_growth_rate;
            let b1 = b.population_growth_rate;
            return a1 - b1;
        },

        sortDecimal_yield(a, b) {
            let a1 = a.median_gross_yield * 100;
            let b1 = b.median_gross_yield * 100;
            return a1 - b1;
        },

        sortInt_sqft(a, b) {
            return a.median_unit_size_sqft - b.median_unit_size_sqft;
        },

        formatter(row, column) {
            return row.address;
        },

        cascaderChange(value) {
            if (value.length > 1) {
                this.filter_cascader = value[1];
            } else {
                this.filter_cascader = value[0];
            }
        },

        restrictStyle({ column }) {
            if (column.className == "score") return "padding-left: 0";
        }
    },

    filters: {
        addPct(val) {
            if (val == 0) return 0;
            return val + "%";
        }
    },

    components: {
        CityRankingSelection,
        BackToTop
    }
};
</script>

<style scoped>
.cityRanking >>> .el-loading-spinner {
    top: 300px;
}
.cityRanking {
    font-family: GothamBook;
}

.cityRanking >>> .hyperlink .flag {
    border: 0.5px solid #d8d8d8;
    box-shadow: 0 1px 1px 0 hsla(0, 0%, 61%, 0.3);
    border-radius: 3px;
}

.title {
    padding: 47px 17px 0 29px;
    background-color: #fff;
}

.title h1 {
    font-family: GothamBold;
    font-size: 28px;
    font-weight: bold;
    color: rgb(7, 35, 63);
    margin-bottom: 15px;
    position: relative;
}

.title h1:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 3px;
    left: -12.4px;
    width: 5px;
    height: 25px;
    background-color: var(--windows-blue);
}

.title p {
    font-family: OpenSans;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.4px;
    color: var(--brownish-grey);
    margin-bottom: 30px;
}

.ranking-table {
    padding: 30px 0;
    background-color: rgb(246, 249, 252);
}

.cityRanking .selection {
    position: relative;
    border-bottom: 1px solid var(--greyish);
    margin-bottom: 30px;
    padding-top: 50px;
    margin-top: 10px;
}

.cityRanking .selection .el-cascader {
    width: 100%;
    height: 75px;
    position: relative;
}
html[lang="zh"] .cityRanking .selection .el-cascader:after {
    content: "所有国家";
}
.cityRanking .selection .el-cascader:after {
    content: "All Countries";
    position: absolute;
    height: 18px;
    line-height: 18px;
    left: 72px;
    /* transform: translateX(-50%); */
    top: 17px;
    text-align: center;
    font-family: GothamBook;
    font-size: 16px;
    letter-spacing: 0.7px;
    color: rgb(51, 51, 51);
}

.cityRanking .selection >>> .el-cascader div,
.cityRanking .selection >>> .el-cascader div input.el-input__inner {
    height: 75px;
}

.cityRanking .selection >>> .el-cascader div input.el-input__inner {
    padding-left: 72px;
    padding-top: 24px;
    font-family: GothamBook;
    font-size: 14px;
    letter-spacing: 0.6px;
    color: rgb(155, 155, 155);
}

.cityRanking .selection >>> .el-cascader .el-cascader__label {
    top: 40%;
    padding-left: 72px;
    font-family: GothamBook;
    font-size: 14px;
    letter-spacing: 0.6px;
    color: #3b6bbf;
}

.cityRanking .selection .share-btn {
    position: absolute;
    right: unset;
    top: 0;
    left: 0;
    right: unset;
    padding: 0 20px 0 0;
}

.cityRanking .selection .share-btn:after {
    content: "";
    width: 20px;
    height: 20px;
    display: inline-block;
    background: url("../../../website_20/static/img/icon-share.svg") no-repeat
        center center;
}

.cityRanking .selection .share-btn:hover .media-box {
    display: block;
}

.cityRanking .selection .share-btn .media-box {
    display: none;
    cursor: pointer;
    height: 40px;
    position: absolute;
    padding: 5px 8px;
    box-shadow: 0 2px 6px 0 rgba(147, 164, 173, 0.16),
        0 1px 2px 0 rgba(147, 164, 173, 0.18);
    background-color: var(--dark-indigo);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    left: 40px;
    top: -9px;
    width: 150px;
    z-index: 10;
}

.cityRanking .selection .share-btn .media-box:after {
    content: "";
    position: absolute;
    top: 14px;
    z-index: 0;
    right: unset;
    left: -5px;
    display: inline-block;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    background-color: var(--dark-indigo);
}

.cityRanking .selection .share-btn .media-box a {
    display: inline-block;
    height: 30px;
    width: 30px;
    background: url("../../../website_20/static/img/icon-share-media.svg")
        no-repeat -46px -23px;
    overflow: hidden;
}

.cityRanking .selection .share-btn .media-box a:nth-child(2) {
    background-position: -83px -23px;
}

.cityRanking .selection .share-btn .media-box a:nth-child(3) {
    background-position: -122px -23px;
}

.cityRanking .selection .share-btn .media-box a:nth-child(4) {
    background-position: -160px -23px;
}

.cityRanking .app_container {
    padding: 0;
}
.cityRanking .app_nav {
    display: flex;
    justify-content: space-between;
    padding: 6px 16px;
    background-color: rgb(246, 249, 252);
}

.cityRanking .app_nav .past_months {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    margin: 0;
    margin-right: 10px;
    box-shadow: 0 1px 3px 0 rgba(155, 155, 155, 0.3);
    position: relative;
}

.cityRanking .app_nav .past_months:after {
    content: "";
    width: 20px;
    height: 14px;
    position: absolute;
    right: 6px;
    top: 8px;
    background: url("../../../website_20/static/img/arrow-down.svg") no-repeat;
    background-size: contain;
}

.cityRanking .app_nav .past_months:last-child {
    margin-right: 0;
}

.cityRanking .app_nav .past_months input {
    border: none;
    height: 30px;
    line-height: 30px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    text-overflow: ellipsis;
    font-size: 11px;
    letter-spacing: 0.5px;
    color: rgb(51, 51, 51);
    padding: 0;
    text-align: left;
    padding-left: 10px;
    padding-right: 22px;
    border-radius: 4px;
}

.cityRanking .past_months .fake_input {
    text-align: center;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    padding-right: 30px;
    width: 100%;
}

.cityRanking .past_months {
    position: static;
    margin-top: 20px;
    margin-bottom: 30px;
    width: 100%;
}

.cityRanking .past_months >>> .el-input__suffix .el-icon-arrow-up {
    font-size: 18px;
    font-weight: bold;
    color: #000;
}

.el-select-dropdown.el-popper {
    margin-top: 0;
}

.el-select-dropdown .popper__arrow {
    display: none;
}

.el-select-dropdown .el-select-dropdown__item {
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    font-family: GothamBook;
    font-weight: normal;
    color: #000;
}

.el-select-dropdown .el-select-dropdown__item.selected {
    color: var(--windows-blue);
}

.el-select-dropdown .el-select-dropdown__item.hover,
.el-select-dropdown .el-select-dropdown__item:hover {
    background-color: var(--duck-egg-blue);
}

.ranking-table >>> .el-cascader .el-input--suffix:before {
    content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    background: url("../../../website_20/static/img/ranking-earth-global.svg")
        no-repeat;
    background-position: 0 0;
}

.ranking-table >>> .el-cascader .el-input--suffix .el-input__inner {
    height: 60px;
}

.ranking-table >>> .el-table {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(155, 155, 155, 0.5);
}
.ranking-table >>> .el-table td,
.ranking-table >>> .el-table th.is-leaf {
    border-bottom-color: rgb(216, 216, 216);
}

.cityRanking >>> .table_header_normal {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.3px;
    color: rgb(51, 51, 51);
}

.cityRanking >>> .el-table .table_header_normal th div {
    white-space: initial;
    word-break: normal;
    line-height: 1;
    overflow: visible;
}

.cityRanking >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #f5f9fd;
}

.cityRanking >>> .table_body_index {
    display: inline-block;
    min-width: 30px;
    text-align: left;
}

.cityRanking >>> .table_body_normal-ff {
    font-family: OpenSans;
    font-size: 14px;
    color: rgb(51, 51, 51);
}

.cityRanking .app_table >>> .el-table .table_body_normal .selection-l {
    display: flex;
}
.cityRanking .app_table >>> .el-table .table_header_normal th {
    padding: 5px 0;
}

.cityRanking .app_table >>> .el-table .table_header_normal th div {
    font-size: 11px;
    padding: 0;
}

.cityRanking .app_table >>> .el-table .table_header_normal .score .cell {
    padding-left: 0;
}

.cityRanking .app_table >>> .el-table .table_body_normal .score .cell {
    padding-left: 0;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}

.cityRanking .app_table >>> .el-table .table_header_normal th .cell {
    padding: 0 20px;
}

.cityRanking .app_table >>> .el-table .table_body_normal .cell {
    padding: 0 20px;
}

.cityRanking .app_table >>> .el-table .table_body_normal .table_body_bold {
    /* width: 70px; */
}

.cityRanking .app_table >>> .el-table th > .cell {
    display: inline-block;
}

.cityRanking .app_table >>> .table_body_normal-ff {
    min-width: 30px;
    text-align: left;
    display: inline-block;
}

.cityRanking >>> .table_body_normal-change.up {
    background-position: -126px 0;
}

.cityRanking >>> .table_body_normal-change.down {
    background-position: -146px 0;
}

.cityRanking >>> .table_body_normal-change .rankNoChange {
    font-family: GothamBook;
    display: inline-block;
    height: 15px;
    width: 15px;
    margin-left: 13px;
}

.cityRanking .app_table >>> .table_body_normal-change .rankNoChange {
    margin-left: 5px;
}

.cityRanking .app_table >>> .hyperlink {
    margin-left: 15px;
    word-break: break-word;
}

.cityRanking .app_table >>> a.hyperlink {
    /* color: #022d60; */
    color: rgb(51, 51, 51);
}

.cityRanking >>> .table_body_normal {
    font-family: GothamBook;
    font-size: 14px;
    letter-spacing: 0.6px;
    font-weight: normal;
    color: rgb(51, 51, 51);
}

.cityRanking >>> .table_body_bold {
    font-family: GothamBold;
    font-weight: bold;
    color: rgb(51, 51, 51);
}

.cityRanking >>> .table_body_highlight {
    font-family: GothamBold;
    font-weight: bold;
    color: var(--windows-blue);
}

.ranking-table >>> .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #3b6bbf;
}

.ranking-table >>> .el-table .descending .sort-caret.descending {
    border-top-color: #3b6bbf;
}

.ranking-table >>> .el-table thead tr {
    height: 74px;
}

.ranking-table >>> .el-table tbody tr {
    height: 70px;
}

.ranking-table
    >>> .el-table
    thead
    tr.table_header_normal
    .is-sortable.ascending
    .cell
    div:first-child,
.ranking-table
    >>> .el-table
    thead
    tr.table_header_normal
    .is-sortable.descending
    .cell
    div:first-child {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.3px;
    color: var(--windows-blue);
}

.ranking-table >>> .table_body_header {
    font-family: GothamBold;
    font-weight: bold;
    letter-spacing: 0.3px;
    line-height: normal;
    font-size: 14px;
    color: rgb(51, 51, 51);
    position: relative;
    white-space: inherit;
}

.ranking-table >>> .table_body_header span {
    font-family: GothamBook;
    letter-spacing: 0.6px;
}

.ranking-table >>> .hyperlink {
    min-width: 133px;
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.6px;
    display: flex;
    align-items: center;
    word-break: break-word;
}

.ranking-table >>> a.hyperlink {
    color: var(--windows-blue);
}

.ranking-table >>> a.hyperlink:hover {
    color: #0d253f;
}

.ranking-table >>> .hyperlink .flag {
    width: 28px;
    height: 22px;
    margin-right: 15px;
    border-radius: 3px;
    border: 0.51px solid #eee;
    flex: 0 0 28px;
}

.cityRanking .selection .el-cascader {
    width: 100%;
}

.cityRanking .selection >>> .el-cascader .el-input__suffix {
    right: 15px;
    color: #000;
}

.cityRanking .selection >>> .el-cascader .el-input__suffix .el-icon-arrow-down {
    font-size: 18px;
    font-weight: bold;
}

.cityRanking >>> .el-table th > .cell {
    display: flex;
    align-items: center;
}

.cityRanking >>> .el-table th.city > .cell {
    justify-content: space-between;
}

.cityRanking >>> .el-table th.city > .cell div {
    padding: 0;
}

.ranking-table >>> .el-table td:first-child,
.ranking-table >>> .el-table th:first-child {
    padding-left: 25px;
}

.ranking-table >>> .el-table td:last-child,
.ranking-table >>> .el-table th:last-child {
    padding-right: 25px;
}

.ranking-table >>> .table_header_normal .score .info {
    position: relative;
    width: 100%;
    text-align: left;
}

.ranking-table >>> .table_header_normal .score .info .info-icon {
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: 0;
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url("../../../website_20/static/img/ranking-table-group.svg")
        no-repeat;
    background-position: -169px 0;
}

.ranking-table >>> .table_header_normal .score .info .info-icon:hover span {
    display: block;
}

.ranking-table >>> .table_header_normal .score .info .info-icon span:before {
    content: "";
    position: absolute;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-left: 1px solid #b9b9b9;
    border-top: 1px solid #b9b9b9;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    z-index: -1;
    background-color: #fff;
    top: -6px;
    right: 50%;
    margin-right: -10px;
}

.ranking-table >>> .el-table th.score,
.ranking-table >>> .el-table__header-wrapper {
    overflow: visible;
}

.ranking-table >>> .table_header_normal .score .info .info-icon span {
    display: none;
    position: absolute;
    box-sizing: border-box;
    transform: translate(50%);
    right: 70px;
    top: 32px;
    z-index: 10;
    width: 182px;
    min-height: 57px;
    font-family: OpenSans;
    font-size: 12px;
    line-height: 1.5;
    color: #666;
    padding: 10px 2px 10px 12px;
    border: 1px solid #b9b9b9;
    box-shadow: 0 1px 4px 0 rgba(185, 185, 185, 0.16),
        0 4px 12px 0 rgba(185, 185, 185, 0.5), 0 0 1px 0 #b9b9b9;
    border-radius: 15px;
    background-color: #fff;
    z-index: 2;
}

.cityRanking >>> .table_body_normal-change {
    display: inline-block;
    height: 15px;
    width: 15px;
    background: url("../../../website_20/static/img/ranking-table-group.svg")
        no-repeat;
    background-position: 0 -20px;
    margin-bottom: -4px;
    margin-left: 4px;
}

@media (max-width: 576px) {
    .container {
        width: 100%;
    }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
    .cityRanking .title {
        padding: 47px 40px 0;
    }

    .cityRanking .selection {
        margin-bottom: 25px;
        padding-top: 0;
        border: 0;
        margin-top: 0;
    }

    .cityRanking .selection .el-cascader {
        width: 255px;
    }

    .cityRanking .selection >>> .el-cascader div input.el-input__inner,
    .cityRanking .selection >>> .el-cascader .el-cascader__label {
        padding-left: 72px;
    }

    .cityRanking .past_months {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 0;
        width: 160px;
        height: 40px;
    }

    .cityRanking .selection .share-btn {
        left: unset;
        padding: 0 0 0 20px;
        right: 0;
    }

    .cityRanking .selection .share-btn .media-box {
        left: unset;
        right: 33px;
    }

    .cityRanking .selection .share-btn .media-box:after {
        right: -5px;
        left: unset;
    }

    .ranking-table >>> .el-table td:first-child {
        padding-left: 20px;
    }

    .ranking-table >>> .el-table th:first-child {
        padding-left: 8px;
    }

    .ranking-table >>> .el-table td:last-child,
    .ranking-table >>> .el-table th:last-child {
        padding-right: 22px;
    }

    .ranking-table >>> .el-table thead tr {
        height: 78px;
    }

    .ranking-table .table_body_header span {
        position: absolute;
        top: 30px;
        display: block;
        left: -6px;
        font-size: 14px;
        width: 98px;
    }

    .ranking-table >>> .table_header_normal .score .info .info-icon {
        top: 5px;
    }

    .ranking-table >>> .table_header_normal .score .info .info-icon span {
        right: 14px;
    }

    /* .cityRanking >>> .el-table .table_header_normal th div {
        white-space: inherit;
    } */
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
    .cityRanking >>> .table_body_normal-change {
        margin-left: 8px;
    }

    .ranking-table >>> .el-table td:first-child {
        padding-left: 60px;
    }

    .ranking-table >>> .el-table th:first-child {
        padding-left: 46px;
    }

    .ranking-table >>> .el-table td:last-child,
    .ranking-table >>> .el-table th:last-child {
        padding-right: 77px;
    }

    .ranking-table .table_body_header span {
        position: static;
    }

    .ranking-table >>> .table_header_normal .score .info .info-icon {
        right: 0;
        top: 0;
    }

    .cityRanking >>> .el-table .table_header_normal th div {
        white-space: initial;
    }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/CityRanking.vue